import { render } from "./OrganisationPriceOverview.vue?vue&type=template&id=2fafc923"
import script from "./OrganisationPriceOverview.vue?vue&type=script&lang=js"
export * from "./OrganisationPriceOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__